export const MathUtils = {
  clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  },

  lerp(a, b, t) {
    return a + (b - a) * t;
  },

  degToRad(degrees) {
    return (degrees * Math.PI) / 180;
  },

  radToDeg(radians) {
    return (radians * 180) / Math.PI;
  },

  wrapAngle(radians) {
    const twoPi = Math.PI * 2;
    let angle = radians % twoPi;
    if (angle > Math.PI) angle -= twoPi;
    if (angle < -Math.PI) angle += twoPi;
    return angle;
  },
};
